import GutXAxisFlagKey from '#components/GutXAxisFlagKey/GutXAxisFlagKey';
import { GutXAxisOrgan } from '@repo/types';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
import styles from './GutXAxisBody.module.css';

type DotProps = {
  flagLevel: GutXAxisOrgan['flag_level'];
  displayName: GutXAxisOrgan['display_name'];
};

export default function Dot({ flagLevel, displayName }: DotProps) {
  return (
    <span className={styles.dot}>
      <span className={styles.card}>
        <Typography variant='label' color='darkPurple' className={styles.title}>
          {displayName}
        </Typography>
        <GutXAxisFlagKey flagLevel={flagLevel} small />
      </span>
      <span className={styles.chevron}>
        <Icon name='chevronForward' size={'xs'} color='white' />
      </span>
    </span>
  );
}
